import { Box, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useAgencyPublications from '@hooks/useAgencyPublications'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import AgencyPublicationListItem from './AgencyPublicationListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'publication_string',
      label: 'Publication Title or ID',
    },
  ]
}

interface AgencyPublicationsProps {
  agencyId: number,
}

const AgencyPublications = (props: AgencyPublicationsProps) => {
  const { agencyId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const agencyPublicationsPayload = useAgencyPublications({
    filters: { ...pageFilters, agency_id: agencyId },
    performHttpRequests: !!agencyId,
    requestOptions: {
      include_agency_publication_publication: true,
    },
    sortKey: 'publication_id',
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredAgencyPublicationsCount,
    filteredAgencyPublications,
    hasFilteredAgencyPublications,
    loading,
  } = agencyPublicationsPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Publications"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <Box flexDirection="column">
        {!loading && !hasFilteredAgencyPublications && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Publications present
            </DashboardModule.BlankState.Title>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredAgencyPublications && (
          // @ts-expect-error TS2322
          <DashboardModule.ScrollableSection maxHeight={600}>
            {filteredAgencyPublications.map((agencyPublication) => {
              const { id } = agencyPublication

              return (
                <AgencyPublicationListItem
                  agencyPublication={agencyPublication}
                  key={id}
                />
              )
            })}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredAgencyPublicationsCount}
          loading={loading}
        />
      </Box>
    </DashboardModule>
  )
}

export default AgencyPublications
